/* SkinVibe: opisy dla czytnika ekranu w widżetach Judge.me w języku strony + bez linku w środku gwiazdek (17.10.2026).
   - Judge.me wstawia opisy dla czytnika ekranu (aria-label, alt, title) po angielsku we wszystkich 8 językach sklepu, także
     na .pl: w HTML z metapola judgeme.widget („Average rating is 4.87 stars”, „90% (148) reviews with 5 star rating”,
     „5 star review”, „<imię> review photo 1”) i we własnych skryptach („Helpful”, „4.26 stars”, „1 star”…„5 stars”,
     formularz opinii). Widoczne napisy są już w języku strony (ustawienia Judge.me per język), a tych opisów panel
     Judge.me nie ma (pola „Text” per język obejmują tylko widoczne napisy). Podmieniamy je tu po narysowaniu widżetu,
     według <html lang> (Shopify ustawia go z języka adresu: pl, en, de, fr, it, es, nl, cs).
   - axe nested-interactive na karcie: Judge.me dopina link „4.87 z 5” (strona sklepu w serwisie judge.me, nowa karta)
     DO ŚRODKA .jdgm-rev-widg__summary-stars, który ma role="img", więc czytnik może pominąć link. Zdejmujemy z kontenera
     role i aria-label, a puste spany gwiazdek chowamy przed czytnikiem (aria-hidden); nazwę niesie tekst linku, który
     Judge.me pisze już w języku strony. Wygląd i działanie linku bez zmian (tylko atrybuty).
   - Tekst, który nie pasuje do wzorca (inna wersja widżetu, zmiana po stronie Judge.me), zostaje bez zmian.
   - MutationObserver: Judge.me dorysowuje widżet, przerysowuje listę przy sortowaniu, filtrze i stronach, plakietki
     w szufladzie koszyka dochodzą później, a gwiazdki formularza dostają title przy najechaniu. Zebrane węzły
     obsługujemy raz na klatkę (requestAnimationFrame); nasze zapisy nie pasują już do wzorców, więc nie ma pętli. */
(function () {
  'use strict';
  if (window.__svJdgmA11y) return;
  window.__svJdgmA11y = true;

  var lang = '', D = null; /* ustawiane w start(), gdy <html lang> jest już w DOM */

  function num(x) {
    var n = parseFloat(x);
    if (isNaN(n)) return x;
    try { return n.toLocaleString(lang, { maximumFractionDigits: 2 }); } catch (e) { return String(n); }
  }
  /* liczba mnoga gwiazdek: [1, 2-4, 5+] dla pl i cs, [1, reszta] dla pozostałych */
  function plural(n, forms) {
    if (forms.length === 3) return n === 1 ? forms[0] : (n >= 2 && n <= 4 ? forms[1] : forms[2]);
    return n === 1 ? forms[0] : forms[1];
  }

  /* Słownik: tłumaczenie 1:1 z angielskiego Judge.me, słowa jak w widocznych napisach Judge.me danego języka
     (ocena/Bewertung/note/valutazione/calificación/beoordeling/hodnocení; opinia/avis/recensione/reseña/recenze).
     Forma: fr vous, cs Vy, it/es/nl na ty, de bez zaimka (słowniczek skilla prawo-i-jezyki, par. 2). Tylko zwykły „-”. */
  var T = {
    pl: {
      avg: 'Średnia ocena: {x} z 5', rev: 'Ocena: {k} z 5', hist: 'Ocena {k} z 5, liczba opinii: {n} ({p}%)',
      star: ['gwiazdka', 'gwiazdki', 'gwiazdek'], photo: 'Zdjęcie {i} z opinii: {name}', photoAlt: 'Zdjęcie z opinii: {name}',
      s: {
        'Helpful': 'Pomocna', 'Not helpful': 'Niepomocna', 'up': 'Pomocna', 'down': 'Niepomocna',
        'Name format': 'Sposób podpisu', 'Rating': 'Ocena', 'YouTube URL': 'Link do filmu na YouTube',
        'Choose a review picture (optional)': 'Dodaj zdjęcie do opinii (nieobowiązkowo)',
        'Choose a review video (optional)': 'Dodaj film do opinii (nieobowiązkowo)',
        'Choose a review picture/video (optional)': 'Dodaj zdjęcie lub film do opinii (nieobowiązkowo)',
        'Review form navigation': 'Nawigacja formularza opinii', 'Review form pages': 'Kroki formularza opinii',
        'Close review form': 'Zamknij formularz opinii', 'Previous step': 'Poprzedni krok', 'Next step': 'Następny krok',
        'Remove file': 'Usuń plik', 'Privacy and Terms': 'Prywatność i regulamin', 'User picture': 'Zdjęcie z opinii'
      }
    },
    de: {
      avg: 'Durchschnittliche Bewertung: {x} von 5', rev: 'Bewertung: {k} von 5',
      hist: '{k} von 5 Sternen, Anzahl der Bewertungen: {n} ({p} %)',
      star: ['Stern', 'Sterne'], photo: 'Foto {i} aus der Bewertung von {name}', photoAlt: 'Foto aus der Bewertung von {name}',
      s: {
        'Helpful': 'Hilfreich', 'Not helpful': 'Nicht hilfreich', 'up': 'Hilfreich', 'down': 'Nicht hilfreich',
        'Name format': 'Namensformat', 'Rating': 'Bewertung', 'YouTube URL': 'YouTube-Link',
        'Choose a review picture (optional)': 'Bild zur Bewertung auswählen (optional)',
        'Choose a review video (optional)': 'Video zur Bewertung auswählen (optional)',
        'Choose a review picture/video (optional)': 'Bild oder Video zur Bewertung auswählen (optional)',
        'Review form navigation': 'Navigation des Bewertungsformulars', 'Review form pages': 'Schritte des Bewertungsformulars',
        'Close review form': 'Bewertungsformular schließen', 'Previous step': 'Vorheriger Schritt', 'Next step': 'Nächster Schritt',
        'Remove file': 'Datei entfernen', 'Privacy and Terms': 'Datenschutz und Bedingungen', 'User picture': 'Foto aus einer Bewertung'
      }
    },
    fr: {
      avg: 'Note moyenne : {x} sur 5', rev: 'Note : {k} sur 5', hist: "Note {k} sur 5, nombre d'avis : {n} ({p} %)",
      star: ['étoile', 'étoiles'], photo: "Photo {i} de l'avis : {name}", photoAlt: "Photo de l'avis : {name}",
      s: {
        'Helpful': 'Utile', 'Not helpful': 'Pas utile', 'up': 'Utile', 'down': 'Pas utile',
        'Name format': 'Format du nom', 'Rating': 'Note', 'YouTube URL': 'Lien YouTube',
        'Choose a review picture (optional)': "Choisissez une photo pour l'avis (facultatif)",
        'Choose a review video (optional)': "Choisissez une vidéo pour l'avis (facultatif)",
        'Choose a review picture/video (optional)': "Choisissez une photo ou une vidéo pour l'avis (facultatif)",
        'Review form navigation': "Navigation du formulaire d'avis", 'Review form pages': "Étapes du formulaire d'avis",
        'Close review form': "Fermer le formulaire d'avis", 'Previous step': 'Étape précédente', 'Next step': 'Étape suivante',
        'Remove file': 'Supprimer le fichier', 'Privacy and Terms': 'Confidentialité et conditions', 'User picture': "Photo d'un avis"
      }
    },
    it: {
      avg: 'Valutazione media: {x} su 5', rev: 'Valutazione: {k} su 5', hist: 'Valutazione {k} su 5, numero di recensioni: {n} ({p}%)',
      star: ['stella', 'stelle'], photo: 'Foto {i} della recensione di {name}', photoAlt: 'Foto della recensione di {name}',
      s: {
        'Helpful': 'Utile', 'Not helpful': 'Non utile', 'up': 'Utile', 'down': 'Non utile',
        'Name format': 'Formato del nome', 'Rating': 'Valutazione', 'YouTube URL': 'Link YouTube',
        'Choose a review picture (optional)': 'Scegli una foto per la recensione (opzionale)',
        'Choose a review video (optional)': 'Scegli un video per la recensione (opzionale)',
        'Choose a review picture/video (optional)': 'Scegli una foto o un video per la recensione (opzionale)',
        'Review form navigation': 'Navigazione del modulo di recensione', 'Review form pages': 'Passaggi del modulo di recensione',
        'Close review form': 'Chiudi il modulo di recensione', 'Previous step': 'Passaggio precedente', 'Next step': 'Passaggio successivo',
        'Remove file': 'Rimuovi file', 'Privacy and Terms': 'Privacy e termini', 'User picture': 'Foto di una recensione'
      }
    },
    es: {
      avg: 'Calificación media: {x} de 5', rev: 'Calificación: {k} de 5', hist: 'Calificación {k} de 5, número de reseñas: {n} ({p} %)',
      star: ['estrella', 'estrellas'], photo: 'Foto {i} de la reseña de {name}', photoAlt: 'Foto de la reseña de {name}',
      s: {
        'Helpful': 'Útil', 'Not helpful': 'No útil', 'up': 'Útil', 'down': 'No útil',
        'Name format': 'Formato del nombre', 'Rating': 'Calificación', 'YouTube URL': 'Enlace de YouTube',
        'Choose a review picture (optional)': 'Elige una foto para la reseña (opcional)',
        'Choose a review video (optional)': 'Elige un video para la reseña (opcional)',
        'Choose a review picture/video (optional)': 'Elige una foto o un video para la reseña (opcional)',
        'Review form navigation': 'Navegación del formulario de reseña', 'Review form pages': 'Pasos del formulario de reseña',
        'Close review form': 'Cerrar el formulario de reseña', 'Previous step': 'Paso anterior', 'Next step': 'Paso siguiente',
        'Remove file': 'Eliminar archivo', 'Privacy and Terms': 'Privacidad y términos', 'User picture': 'Foto de una reseña'
      }
    },
    nl: {
      avg: 'Gemiddelde beoordeling: {x} van de 5', rev: 'Beoordeling: {k} van de 5',
      hist: 'Beoordeling {k} van de 5, aantal beoordelingen: {n} ({p}%)',
      star: ['ster', 'sterren'], photo: 'Foto {i} bij de beoordeling van {name}', photoAlt: 'Foto bij de beoordeling van {name}',
      s: {
        'Helpful': 'Nuttig', 'Not helpful': 'Niet nuttig', 'up': 'Nuttig', 'down': 'Niet nuttig',
        'Name format': 'Naamweergave', 'Rating': 'Beoordeling', 'YouTube URL': 'YouTube-link',
        'Choose a review picture (optional)': 'Kies een foto voor je beoordeling (optioneel)',
        'Choose a review video (optional)': 'Kies een video voor je beoordeling (optioneel)',
        'Choose a review picture/video (optional)': 'Kies een foto of video voor je beoordeling (optioneel)',
        'Review form navigation': 'Navigatie van het beoordelingsformulier', 'Review form pages': 'Stappen van het beoordelingsformulier',
        'Close review form': 'Beoordelingsformulier sluiten', 'Previous step': 'Vorige stap', 'Next step': 'Volgende stap',
        'Remove file': 'Bestand verwijderen', 'Privacy and Terms': 'Privacy en voorwaarden', 'User picture': 'Foto uit een beoordeling'
      }
    },
    cs: {
      avg: 'Průměrné hodnocení: {x} z 5', rev: 'Hodnocení: {k} z 5', hist: 'Hodnocení {k} z 5, počet recenzí: {n} ({p} %)',
      star: ['hvězdička', 'hvězdičky', 'hvězdiček'], photo: 'Fotka {i} z recenze: {name}', photoAlt: 'Fotka z recenze: {name}',
      s: {
        'Helpful': 'Užitečná', 'Not helpful': 'Neužitečná', 'up': 'Užitečná', 'down': 'Neužitečná',
        'Name format': 'Formát jména', 'Rating': 'Hodnocení', 'YouTube URL': 'Odkaz na YouTube',
        'Choose a review picture (optional)': 'Vyberte fotku k recenzi (volitelné)',
        'Choose a review video (optional)': 'Vyberte video k recenzi (volitelné)',
        'Choose a review picture/video (optional)': 'Vyberte fotku nebo video k recenzi (volitelné)',
        'Review form navigation': 'Navigace formuláře recenze', 'Review form pages': 'Kroky formuláře recenze',
        'Close review form': 'Zavřít formulář recenze', 'Previous step': 'Předchozí krok', 'Next step': 'Další krok',
        'Remove file': 'Odebrat soubor', 'Privacy and Terms': 'Soukromí a podmínky', 'User picture': 'Fotka z recenze'
      }
    }
  };

  function fill(tpl, v) {
    return tpl.replace(/\{(\w+)\}/g, function (m, k) { return v[k] != null ? v[k] : m; });
  }
  function tr(s, isAlt) {
    if (!D || !s) return null;
    var t = s.trim(), m;
    if (Object.prototype.hasOwnProperty.call(D.s, t)) return D.s[t];
    if ((m = /^Average rating is ([\d.]+) stars?$/.exec(t))) return fill(D.avg, { x: num(m[1]) });
    if ((m = /^(\d+)% \((\d+)\) reviews? with (\d) stars? rating$/.exec(t))) return fill(D.hist, { p: m[1], n: m[2], k: m[3] });
    if ((m = /^(\d) stars? review$/.exec(t))) return fill(D.rev, { k: m[1] });
    if ((m = /^(\d) stars?$/.exec(t))) { var k = +m[1]; return k + ' ' + plural(k, D.star); }
    if ((m = /^(\d+\.\d+) stars?$/.exec(t))) return fill(D.avg, { x: num(m[1]) });
    if ((m = /^(.+) review (?:photo|picture) (\d+)$/.exec(t))) return fill(D.photo, { name: m[1], i: m[2] });
    if (isAlt && (m = /^(.+) review (?:photo|picture)$/.exec(t))) return fill(D.photoAlt, { name: m[1] });
    return null;
  }

  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var SEL = '[class*="jdgm"][aria-label], [class*="jdgm"] [aria-label], img.jdgm-gallery__thumbnail, .jdgm-widget img[alt], ' +
    '.jdgm-rev__thumb-btn[title], .jdgm-form a.jdgm-star[title], .jdgm-rev-widg__summary-stars';

  function fixSummary(el) {
    if (el.getAttribute('role') !== 'img' || !el.querySelector(FOCUSABLE)) return;
    el.removeAttribute('role');
    el.removeAttribute('aria-label');
    var stars = el.querySelectorAll('.jdgm-star');
    for (var i = 0; i < stars.length; i++) stars[i].setAttribute('aria-hidden', 'true');
  }
  function fixEl(el) {
    if (el.classList && el.classList.contains('jdgm-rev-widg__summary-stars')) fixSummary(el);
    var a = ['aria-label', 'title', 'alt'];
    for (var i = 0; i < a.length; i++) {
      var v = el.getAttribute(a[i]);
      if (!v) continue;
      var t = tr(v, a[i] === 'alt');
      if (t && t !== v) el.setAttribute(a[i], t);
    }
  }
  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(SEL)) fixEl(root);
    var list = root.querySelectorAll ? root.querySelectorAll(SEL) : [];
    for (var i = 0; i < list.length; i++) fixEl(list[i]);
    /* link dopięty do środka gwiazdek: obsłuż kontener nad dodanym węzłem */
    var up = root.closest ? root.closest('.jdgm-rev-widg__summary-stars') : null;
    if (up && up !== root) fixSummary(up);
  }

  /* 17.10 (sesja analityki): kolejka obsługiwana po narysowaniu klatki (setTimeout 60 ms zamiast requestAnimationFrame),
     a filtr „czy to Judge.me” liczony dopiero tam, nie w wywołaniu MutationObserver - żeby nic nie dokładało się
     do czasu reakcji na dotknięcie (INP), np. przy przerysowaniu sekcji karty produktu albo szuflady koszyka. */
  var pending = [], raw = [], scheduled = false;
  function isJdgm(n) {
    var cls = typeof n.className === 'string' ? n.className : '';
    return cls.indexOf('jdgm') !== -1 || (n.querySelector && n.querySelector('[class*="jdgm"]')) ||
      (n.closest && n.closest('[class*="jdgm"]'));
  }
  function flush() {
    scheduled = false;
    var q = pending, r = raw; pending = []; raw = [];
    if (r.length > 400) { q = [document.body]; r = []; }
    for (var j = 0; j < r.length; j++) { try { if (r[j].isConnected && isJdgm(r[j])) q.push(r[j]); } catch (e) {} }
    for (var i = 0; i < q.length; i++) { try { scan(q[i]); } catch (e) {} }
  }
  function schedule() { if (!scheduled) { scheduled = true; setTimeout(flush, 60); } }
  function queue(n) {
    if (!n || n.nodeType !== 1) return;
    pending.push(n); schedule();
  }

  function start() {
    lang = String(document.documentElement.lang || '').slice(0, 2).toLowerCase();
    D = T[lang] || null; /* en (.eu, .global) i nieznany język: same poprawki struktury, teksty Judge.me zostają */
    try { scan(document.body); } catch (e) {}
    if (!window.MutationObserver) return;
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var r = recs[i];
        if (r.type === 'attributes') {
          var c = r.target.className;
          if (typeof c === 'string' && c.indexOf('jdgm') !== -1) queue(r.target);
          continue;
        }
        for (var j = 0; j < r.addedNodes.length; j++) {
          var n = r.addedNodes[j];
          if (n.nodeType !== 1) continue;
          /* filtr Judge.me dopiero w flush() (szuflada koszyka, przerysowanie listy) */
          raw.push(n); schedule();
        }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label', 'title', 'alt', 'role'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
